// The four carnival games, in the order the hub shows them (game.php). `key` matches the backend's
// GAMES list; the game itself is a static canvas build served from /carnival/games/<folder>/.
export const GAMES = [
  {
    key: 'chain',
    bg: '#1d2f7a', // fills the letterbox bars beside the game (matches its own backdrop)
    headerSpace: true, // the game has buttons in its top-left corner — keep it clear of the logo/Back
    title: 'Christmas Chain',
    card: '/carnival/img/Christmas_Chain.png',
    src: '/carnival/games/chain/index.html',
    rules: [
      'Click on a ball to add it to the chain.',
      'Match 3 or more balls at a time to create a chain of the same balls.',
      'Points will only be added for your first attempt.',
    ],
  },
  {
    key: 'skater',
    bg: '#4a9be6', // fills the letterbox bars beside the game (matches its own backdrop)
    title: 'Santa The Skater',
    card: '/carnival/img/Skater_Santa.png',
    src: '/carnival/games/skater/index.html',
    rules: [
      'You have 2 lifelines available.',
      'Collect as many stars as possible by pressing the spacebar or tapping to jump.',
      'Avoid obstacles to prevent negative marking.',
      'Points will only be added for your first attempt.',
      "If you collect 100 coins, you'll earn an extra life.",
      'Check the instructions for more details on gameplay.',
    ],
  },
  {
    key: 'slide',
    bg: '#d2eff9', // fills the letterbox bars beside the game (matches its own backdrop)
    title: 'Santa Slide',
    card: '/carnival/img/Santa_slide.png',
    src: '/carnival/games/slide/index.html',
    rules: [
      'Help Santa navigate the maze to reach the exit.',
      'Move the blocks around to create space for Santa.',
      'Complete all 3 levels to earn points.',
      'Points will only be added for your first attempt.',
    ],
  },
  {
    key: 'arcade',
    title: 'Pixel Christmas',
    card: '/carnival/img/Pixel_Christmas.png',
    src: '/carnival/games/arcade/index.html',
    rules: [
      "Play the game of Tetris with Santa's presents.",
      'Use the arrow keys as shown to drop and rotate the presents.',
      'Earn points for each completed line.',
      'You have 3 minutes to score as many points as possible.',
      'Points will only be added for your first attempt.',
    ],
  },
];

export const gameByKey = (key) => GAMES.find((g) => g.key === key);
